import { useBugReportsQuery } from '@generated/graphql';
import { Stack } from '@mui/material';
import PageTitle from 'components/common/PageTitle';
import TableLayout from 'layout/TableLayout';
import { DEFAULT_LIMIT } from 'layout/TableLayout/components/TablePagination';
import BUG_REPORT_LIST_COLUMNS from './config/columns';
import BUG_REPORT_LIST_FILTERS from './config/filters';
import { BugReportListData } from './types';

const BugReportListPage = () => {
  const { data, loading, refetch } = useBugReportsQuery({
    variables: {
      limit: DEFAULT_LIMIT,
      page: 0,
    },
  });

  const bugReports = data?.bugReports?.data || [];
  const totalCount = data?.bugReports?.totalCount || 0;

  return (
    <Stack spacing={2.5}>
      <PageTitle title='Список баг-репортов' />
      <TableLayout<BugReportListData>
        columns={BUG_REPORT_LIST_COLUMNS}
        filters={BUG_REPORT_LIST_FILTERS}
        data={bugReports}
        loading={loading}
        emptyPlaceholderText='Пока нет баг-репортов'
        totalCount={totalCount}
        rowsPerPageText='Баг-репортов на странице'
        refetch={refetch}
      />
    </Stack>
  );
};

export default BugReportListPage;
